import { render, staticRenderFns } from "./paperconfig.vue?vue&type=template&id=4648cfe3&scoped=true&"
import script from "./paperconfig.vue?vue&type=script&lang=js&"
export * from "./paperconfig.vue?vue&type=script&lang=js&"
import style0 from "./paperconfig.vue?vue&type=style&index=0&id=4648cfe3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648cfe3",
  null
  
)

export default component.exports